/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import ComponentInit from '../js/utils/ComponentInit';
import AlertBanner from './AlertBanner/AlertBanner';
import CardCarousel from './CardCarousel/CardCarousel';
import FixedHeader from './Header/Shared/FixedHeader';
import HeaderSearch from './Header/Shared/HeaderSearch';
import MainNav from './Header/Desktop/MainNav';
import MobileNav from './Header/Mobile/MobileNav';
import NavbarToggler from './Header/Mobile/NavbarToggler';
import SearchToggler from './Header/Mobile/SearchToggler';
import EventsBlock from './EventsBlock/EventsBlock';
import AnchorLinksMenu from './AnchorLinksMenu/AnchorLinksMenu';
import EventBanner from './PageBanners/EventBanner/EventBanner';
import EventLandingBanner from './PageBanners/EventLandingBanner/EventLandingBanner';
// import EventCalendar from './EventCalendar/EventCalendar';
import './UserIdentity/UserIdentity';
import FeaturedEventCarousel from './FeaturedEventCarousel/FeaturedEventCarousel';
// import BallotedDining from './Forms/Dining/BallotedDining/BallotedDining';
import FormPanel from './FormPanel/FormPanel';
import Acknowledgement from './Acknowledgement/Acknowledgement';
import Footer from './Footer/Footer';
import MembershipLevelCarousel from './MembershipLevelCarousel/MembershipLevelCarousel';
import PageBanner from './PageBanners/PageBanner/PageBanner';
import CarouselSection from './CarouselSection/CarouselSection';
import FormSection from './FormSection/FormSection';
import HeroBanner from './PageBanners/HeroBanner/HeroBanner';

// import AssetsListing from './AssetsListing/AssetsListing';
// import LocationListing from './LocationListing/LocationListing';
// import ArticleListing from './ArticleListing/ArticleListing';
// import PeopleListing from './PeopleListing/PeopleListing';
// import SearchBlock from './SearchBlock/SearchBlock';

// import './AlgoliaSearch/AlgoliaSearch';

// // Format:
// // data-component-name: ComponentFunction
// // we shall order these in page load critical first
const componentList = {
    AlertBanner,
    CardCarousel,
    FixedHeader,
    HeaderSearch,
    MainNav,
    MobileNav,
    NavbarToggler,
    SearchToggler,
    EventsBlock,
    AnchorLinksMenu,
    EventBanner,
    FeaturedEventCarousel,
    EventLandingBanner,
    FormPanel,
    Acknowledgement,
    Footer,
    MembershipLevelCarousel,
    PageBanner,
    CarouselSection,
    FormSection,
    HeroBanner,
    // BallotedDining,
    // EventCalendar,
    // AssetsListing,
    // LocationListing,
    // ArticleListing,
    // PeopleListing,
    // SearchBlock,
};

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
